// The degree programs the public directory (transitionu.health/programs) lists.
// Mirrors common/programGeo.js PROGRAMS on the public site: `id` is the API program_id,
// `slug` the program's slug on the public program page.
export const TU_DIRECTORY_PROGRAMS = [
  { id: 17, slug: 'licensed-practical-nursing', title: 'Licensed Practical Nurse', abbr: 'LPN' },
  { id: 21, slug: 'associate-degree-nursing', title: 'Associate Degree in Nursing', abbr: 'ADN' },
  { id: 35, slug: 'bachelor-of-science-nursing', title: 'Bachelor of Science in Nursing', abbr: 'BSN' },
  { id: 99, slug: 'dental-hygiene', title: 'Dental Hygiene', abbr: 'RDH' },
  { id: 79, slug: 'radiologic-technology', title: 'Radiologic Technology', abbr: 'RT(R)' },
  { id: 11, slug: 'respiratory-therapist', title: 'Respiratory Therapist', abbr: 'RRT' },
  { id: 100, slug: 'diagnostic-medical-sonography', title: 'Diagnostic Medical Sonography', abbr: 'DMS' },
  { id: 20, slug: 'physical-therapy-assistant', title: 'Physical Therapist Assistant', abbr: 'PTA' },
];
